import React,{useState,useEffect} from "react";
import axios from "./axios";
import "./Row.css";
import Youtube from "react-youtube";
import movieTrailer from "movie-trailer";

const baseurl = "https://image.tmdb.org/t/p/original/";
function Row({title,fetchUrl,isLargeRow}){
    //states are like variables to store temporary data
    const [movies,setMovies] = useState([]);
    const [trailerUrl,setTrailerUrl] = useState("");
    // A snippet that runs based on specific conditions/variables
    useEffect(()=>{
        //pull information when the component loads,[]blank run once
        async function fetchData(){
            const request = await axios.get(fetchUrl);
            setMovies(request.data.results);
            return request;
        }
        fetchData();
    },[fetchUrl]);
    const opts = {
        height: '390',
        width: '100%',
        playerVars: {
          autoplay: 1,
        },
      };

      const handleClick = (movie) => {
        if (trailerUrl){
            setTrailerUrl('');
        } else {
            movieTrailer(movie?.name || "")
            .then((url) => {
    
                const urlParams = new  URLSearchParams(new URL(url).search);
                setTrailerUrl(urlParams.get("v"));
    
            }) .catch((error) => console.log(error));
        }
    }
    
    
    return(
        <div className = "row">
            <h2>{title}</h2>
           
            {/*container*/}
            <div className = "row_posters">
                {/* several row posters */}
                {movies.map(movie => (
                    <img 
                    key={movie.id}
                    onClick={()=>handleClick(movie)}
                    className={`row_poster ${isLargeRow && "row_posterLarge"}`}
                    src = {`${baseurl}${isLargeRow ? movie.poster_path : movie.backdrop_path}`} 
                    alt ={movie.name}/>
                ))}

            </div>
            {trailerUrl &&<Youtube videoId={trailerUrl} opts={opts}/>}
            
        </div>
    )
}

export default Row;